import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Titre dynamique de la réassurance livraison (PDP) — Maison Empereur.
 * Calqué sur `product-inventory.js` (Horizon) : à chaque changement de variante,
 * on relit le titre rendu par le Liquid dans le HTML de section re-rendu
 * (seuil franco, tag « Hors franco », panier décidés côté serveur, aucune règle ici).
 * Après un ajout au panier (`shopify:cart:lines-update`, le panier peut franchir
 * le seuil), on re-fetche la section courante avec `section_id` pour le même motif.
 */
class MePdpReassureShipping extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate);
  }

  /** Recopie titre + préfixe de sous-titre depuis un document re-rendu. */
  #applyFrom(html) {
    const next = html.querySelector('me-pdp-reassure-shipping');
    if (!next) return;
    this.textContent = next.textContent;
    const prefix = this.closest('.me-pdp-reassure-item')?.querySelector('[data-me-shipping-prefix]');
    const nextPrefix = next.closest('.me-pdp-reassure-item')?.querySelector('[data-me-shipping-prefix]');
    if (prefix && nextPrefix) prefix.textContent = nextPrefix.textContent;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        this.#applyFrom(html);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[me-pdp-reassure-shipping] Event promise rejected:', error);
      });
  };

  #handleCartUpdate = async (event) => {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;
    try {
      // L'événement part au début de la requête panier : attendre sa promesse,
      // sinon la section re-fetchée voit encore l'ancien panier.
      if (event?.promise) await event.promise.catch(() => {});
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      this.#applyFrom(html);
    } catch (error) {
      console.warn('[me-pdp-reassure-shipping] cart refresh failed:', error);
    }
  };
}

if (!customElements.get('me-pdp-reassure-shipping')) {
  customElements.define('me-pdp-reassure-shipping', MePdpReassureShipping);
}
